module.exports = __webpack_public_path__ + "media/site_templates/www.gascooktopinstallation.com.au/images/our_services_2-d54746a16cf3eaea5cda2320dd08f9b1.jpg";